import * as React           from 'react';
import GroupsGrid from "../../components/bo-core/grids/GroupsGrid/GroupsGrid";

class Groups extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#2D3436', height: '100%'}}>
                <GroupsGrid/>
            </div>
        );
    }
}
export default Groups



// WEBPACK FOOTER //
// ./app/views/bo-core/Groups.tsx